import bluebird from 'bluebird';
import styles from './stylus/styles.styl';

global.DEBUG = true;
global.Promise = bluebird;

Promise.config({
  longStackTraces: true,
});

const Application = require('./js/App.es6');

console.info('main');
const app = new Application();



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/main.es6
 **/